import { createAction, props } from '@ngrx/store';
import { AdminOrganizationUser } from 'src/app/admin/models/organization.model';
import { UserSearchApiError } from './user-search.errors';

export const LoadUserSearchResults = createAction(
  '[UserSearch] Load User Search',
  props<{ email: string }>(),
);

export const SetUserSearchResults = createAction(
  '[UserSearch] Set User Search',
  props<{ user: AdminOrganizationUser }>(),
);

export const SetUserSearchError = createAction(
  '[UserSearch] Set User Search Error',
  props<{ error: UserSearchApiError }>(),
);
